// extracted by mini-css-extract-plugin
module.exports = {"cardArea":"plans_cardArea__23axT","container":"plans_container__xdx4J"};